import { render } from "./CenteredTitle.vue?vue&type=template&id=31831946"
import script from "./CenteredTitle.vue?vue&type=script&lang=js"
export * from "./CenteredTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__